import { render } from "./HelpMFABlock.vue?vue&type=template&id=39a7994d&scoped=true"
import script from "./HelpMFABlock.vue?vue&type=script&lang=js"
export * from "./HelpMFABlock.vue?vue&type=script&lang=js"

import "./HelpMFABlock.vue?vue&type=style&index=0&id=39a7994d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a7994d"]])

export default __exports__